import { render } from "./Step4.vue?vue&type=template&id=4f2b19b3&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=4f2b19b3&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2b19b3"]])

export default __exports__